var render = function render(){var _vm=this,_c=_vm._self._c;return _c('social-media-container',_vm._l((_vm.socialMediaItems),function(item){return _c('social-media-icon',{key:item.icon},[_c('a',{attrs:{"href":item.url,"target":item.target}},[_c('i',{class:'fab ' + item.icon})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }